export { default } from './Tabs';